import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { getMinimumBound, updateMinimumBound, getMaximumBound, updateMaximumBound } from "containers/Setup/reducer";
import { NumericInput } from "components/Inputs/NumericInput";
import styles from "./style.module.css";
import { getProjectSegments, getSegmentRunId } from "containers/Project/reducer";
const ProjectBounds = ({ projectId, updateChangesSaved }) => {
    const dispatch = useDispatch();
    const segments = useSelector((state) => getProjectSegments(state, projectId));
    const runIds = useSelector((state) => segments.map((s) => getSegmentRunId(state, projectId, s.id)));
    const minimumBound = useSelector((state) => getMinimumBound(state, runIds[0]));
    const maximumBound = useSelector((state) => getMaximumBound(state, runIds[0]));
    return (React.createElement("div", { style: { marginBottom: "40px" } },
        React.createElement("div", { className: styles.deployHeader }, "Project Bounds"),
        React.createElement("div", { className: styles.deploySubHeader, style: { marginBottom: "10px" } }, "Do you want to limit your continuous outcome predictions with minimum and maximum bounds?"),
        React.createElement("div", { style: { display: "flex" } },
            React.createElement(NumericInput, { value: minimumBound, onChange: (value) => {
                    if (value !== minimumBound) {
                        updateChangesSaved();
                    }
                    for (const runId of runIds) {
                        dispatch(updateMinimumBound(runId, value));
                    }
                }, placeholder: "Minimum Bound Value", style: { marginRight: "10px" } }),
            React.createElement(NumericInput, { value: maximumBound, onChange: (value) => {
                    if (value !== maximumBound) {
                        updateChangesSaved();
                    }
                    for (const runId of runIds) {
                        dispatch(updateMaximumBound(runId, value));
                    }
                }, placeholder: "Maximum Bound Value" }))));
};
export default ProjectBounds;
